export const acceptAnyValue = () => {
  return true;
};
